const VIEW_MODE = 1;
const EDIT_MODE = 0;

export const RepositoryProject = {
  namespace: true,

  state: {
    projectDeliveries: [],
    projectSites: [],
    projectQuickAccesses: [],
    projectViewMode: 1,
  },

  mutations: {
    addProjectDeliveries(state, deliveries) {
      state.projectDeliveries = deliveries;
    },

    addProjectSites(state, sites) {
      state.projectSites = sites;
    },

    toggleProjectViewMode(state, mode) {
      state.projectViewMode = mode;
    },

    updateProject(state, data) {
      state.project.data.field = data.value;
    },

    addProjectQuickAccesses(state, data) {
      state.projectQuickAccesses = data;
    },
  },

  actions: {
    async getProjectDeliveries(context, projectUuid) {
      const response = await this._vm.$api('projects.deliveries', {
        version: '1.0',
        project: projectUuid,
      });
      context.commit('addProjectDeliveries', response.data.data);
    },

    async getProjectSites(context, projectUuid) {
      const response = await this._vm.$api('projects.sites', {
        version: '1.0',
        project: projectUuid,
      });
      context.commit('addProjectSites', response.data.data);
    },

    async getProjectQuickAccesses(context, { repository, project }) {
      const response = await this._vm.$api('repositories.projects.quickAccess.index', {
        version: '1.0',
        repository,
        project,
      });
      context.commit('addProjectQuickAccesses', response.data.data);
    },

    toggleProjectViewMode(context, mode) {
      let currentUrl = window.location.pathname;
      let currentViewMode = +currentUrl.substr(currentUrl.length - 1);
      let viewMode = mode ? VIEW_MODE : EDIT_MODE;
      if (viewMode !== currentViewMode) {
        let currentState = history.state;
        let currentTitle = document.title;
        let newUrl = currentUrl.replace(/.$/, viewMode); // replace last char in string
        window.history.pushState(currentState, currentTitle, newUrl);
      }
      context.commit('toggleProjectViewMode', viewMode);
    },
  },
};
